/* eslint-disable import/order */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { CircularProgress, LinearProgress } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import DoneIcon from '@material-ui/icons/Done';
import Alert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { addHours, format, isBefore, startOfToday } from 'date-fns';
import { Link, useParams } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';

import PageTitleAndFilter from 'components/PageTitleAndFilter';
import Layout from 'containers/layouts/layout';
import ArrowRight from 'images/icons/arrows/arrowRightWhiteOutline.svg';
import ArrowBack from 'images/icons/arrows/arrowBackBackgroundBlue.svg'

import makePut from 'services/useFetch/makePut';
import Environment from 'utils/environments';
import history from 'utils/history';
import numberToReal from 'utils/numberToReal';

import ReceiverDetailsCards from './cards';

import AcrescimosDescontos from '../dialogs/AdditionalDiscounts';
import ConfirmationDialog from '../dialogs/ConfirmationDialog';
import DialogCompleteNoteMobile from '../dialogs/DialogCompleteNoteMobile';

import './styles.scss';
import OverlayFooter from 'containers/footerMobile/footer';

function ReceiverDetails() {
  const environments = Environment(process.env.REACT_APP_ENV);
  const { id: paramsID, receiverId } = useParams();
  const [getId, setGetId] = useState(paramsID)
  const [getReceiveId, setGetReceiveId] = useState(receiverId)
  const [receiverData, setReceiverData] = useState([])
  const [orders, setOrders] = useState([])
  const [openModalDescontos, setOpenModalDescontos] = useState(false)
  const [openModalOrder, setOpenModalOrder] = useState(false)
  const [selectedReceiveDate, setSelectedReceiveDate] = useState(new Date())
  const [submitted, setSubmitted] = useState(false)
  const [errMsg, setErrMsg] = useState(false)
  const [contacts, setContacts] = useState(false)
  const [isCompleteNote, setIsCompleteNote] = useState(false)
  const [currentOrder, setCurrentOrder] = useState({})
  const [currentQuantity, setCurrentQuantity] = useState({})
  const [isDivergency, setIsDivergency] = useState(false)
  const [dayOfTheWeek, setDayOfTheWeek] = useState(["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"])
  const [totalReceiver, setTotalReceiver] = useState(0)
  const [totalCards, setTotalCards] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [sendReceivedscards, setSendReceivedscards] = useState([])
  const [openFloatButton, setOpenFloatButton] = useState(false)
  const [toastSuccess, setToastSuccess] = useState(false)
  const [toastError, setToastError] = useState(false)
  const [openConfirmatioDialog, setOpenConfirmatioDialog] = useState(false)
  const [receivementDate, setReceivementDate] = useState(new Date())
  const [openNfceModal, setOpenNfceModal] = useState()
  const [size, setSize] = useState('auto')


  useEffect(() => {
    const handleScroll = () => {
      setSize(document?.querySelector('main')?.scrollTop > 8 ? '65px' : 'auto');
    };
 
    if (!document.querySelector('main')) return;
 
    document.querySelector('main').addEventListener('scroll', handleScroll);
 
    return () => {
      document
        ?.querySelector('main')
        ?.removeEventListener('scroll', handleScroll);
    };
  }, []);


  async function getData() {
    setLoading(true)
    const response = await fetch(`${environments.orders}/orders?orderNumber=${getReceiveId}&originId=${getId}`);
    const data = await response.json();
    setReceiverData(data.content[0])
    setOrders(data?.content[0].orderItems)   
    setLoading(false) 
  }  

  useEffect(() => {
    const allTotalCards = totalCards.reduce(
      (acc, item) => acc + parseFloat(item.value), 0
    )
    setTotalReceiver(allTotalCards)
  }, [totalCards])

  useEffect(() => {
    
    const filteredOrders = orders.filter((order) => order?.sku?.status !== "RECEIVED")
    let count = 0
    const totalList = []

    for (let i = 0; i < filteredOrders?.length; i++) {
      count += parseFloat(filteredOrders[i]?.costs?.total)
      const currentValueCard = {id: filteredOrders[i]._id, value: filteredOrders[i]?.costs?.total}
      totalList.push(currentValueCard)
      // setTotalReceiver(count)
    }
    setTotalCards(totalList)
  }, [orders])

  useEffect(() => {
    getData()
  }, [])

  const handleCloseModal = () => {
    setContacts([])
    setSelectedReceiveDate(new Date())
    setOpenModalDescontos(false)
    setOpenModalOrder(false)
    setErrMsg(false)
    setSubmitted(false)
  }

  const handleClose = (event, reason) => {
    setErrMsg(false)
    handleCloseModal()
    history.push(`/recebimento/${paramsID}`)
  }

  function handleReceiveDateChange(date) {
    setSelectedReceiveDate(date)
  }

  function handleChangeStatusCard(status, estado) {
    
  }

  const showTooltipNotes = (order) => {
    for (let i = 0; i < order?.length; i++) {
      if(order[i]?.sku?.provider) {
        const { shipping, discount, otherCosts, segCosts } = order[i].sku.provider;
        if(!order[i].sku.provider.hasOwnProperty('shipping') || !order[i].sku.provider.hasOwnProperty('discount') || !order[i].sku.provider.hasOwnProperty('otherCosts') || !order[i].sku.provider.hasOwnProperty('segCosts')) return false
        if (shipping !== 0 || discount !== 0 || otherCosts !== 0 || segCosts !== 0) {
          return true;
        }
        return false 
      }
    return false
    }
  }

  function backgroundColorStatus(status, dlvrDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return '#08AA15'
        }
        return '#AA8208'
      }
      
      if (receipt.status.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument.toUpperCase() === 'VALIDATE')) {
        return '#5062F0'
      }
    }

    if (status == "IN PROGRESS") {
      return inProgress()
    }

    if (status == "RECEIVED") {
      return "#D2F9D6"
    }

    if (status == "NOT RECEIVED" ) {
      return "#F53D4C"
    }

    if (status == "RETURNED") {
      return "#660008"
    }

    if (status == "PENDING") {
      return "#d3d3d3"
    }
    
  }

  function wordColorStatus(status, dlvrDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return '#08AA15'
        }
        return '#AA8208'
      }
      
      if (receipt.status.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument.toUpperCase() === 'VALIDATE')) {
        return '#5062F0'
      }
    }

    if (status == "IN PROGRESS") {
      return inProgress()
    }

    if (status == "RECEIVED") {
      return "#08AA15"
    }

    if (status == "RETURNED") {
      return "#AA0816"
    }

    if(status == "NOT RECEIVED") {
      return "#F53D4C"
    }

    if (status == "PENDING") {
      return "#0B1A8E"
    }
  }

  function handleTranslateStatus(status, dlvrDate, receipt) {
    const { orderItems } = receipt

    const inProgress = () => {
      if (receipt?.status?.toUpperCase() === 'IN PROGRESS' && isBefore(addHours(new Date(receipt.deliveryDate), 3), startOfToday())) {
        if (orderItems?.some(el => el?.sku?.status === "RECEIVED") && !orderItems.every(el => el?.sku?.status === "RECEIVED")) {
          return 'Recebido parcialmente'
        }
        return 'Atrasado'
      }
          
      if (receipt?.status?.toUpperCase() === 'IN PROGRESS' && (receipt.statusPaymentDocument?.toUpperCase() === 'PENDING' || receipt.statusPaymentDocument?.toUpperCase() === 'VALIDATE')) {
        return 'Andamento'
      }
    }

    const stts = {
      "RECEIVED": "Recebido",
      "IN PROGRESS": inProgress(),
      "RETURNED": "Devolvido",
      "NOT RECEIVED": "Não Recebido",
      "PENDING": "Aprovação" 
    }
    return stts[status]
  }

  const openCompleteNoteModal = () => {
    setOpenModalOrder(true)
    setIsCompleteNote(true)
  }

  const handleBackButtonFilter = () => {
    history.push(`/recebimento/${paramsID}`)
  }

  const handleCloseToast = () => {
    setToastSuccess(false)
  }

  const handleReceivementDate = (date) => {
    setReceivementDate(date)
  }

  const handleSendReceiverRequest = () => {
    setLoading(true)
    makePut("ordersEndPoint", sendReceivedscards, handleResponse, `${receiverId}/skus?receiveDate=${format(receivementDate.valueOf() + 10800000, 'yyyy-MM-dd')}`)
    
    function handleResponse(status, response) {
      if (status === true) {
        setOpenConfirmatioDialog(false)
        setToastSuccess(true)
        setOpenFloatButton(false)
        setModalLoading(false)
        getData()
        setLoading(false)
        history.push(`/recebimento/${paramsID}`)
      }
      else {
        setToastError(true)
        setOpenFloatButton(false)
        setModalLoading(false)
        setLoading(false)
        getData()

      }
    }
  }

  const nfsReceived = [];
  const nfsUnique = [];

  const nfsCountItemsReceived = receiverData?.orderItems?.filter(
      (order) => order?.sku?.status === 'RECEIVED'
  );
  nfsCountItemsReceived?.map((items) => {
    if (
        items.itemsPaymentDocument &&
        nfsReceived.indexOf(
        items.itemsPaymentDocument.paymentDocumentNumber !== -1
        )
        ) {
            nfsReceived.push(
              items.itemsPaymentDocument.paymentDocumentNumber
            );
          }
        });

      // função que exibe as notas fiscais únicas recebidas por pedido
      const setNFSUniqueReceived = new Set(nfsReceived);

      receiverData?.orderItems?.map((items) => {
        if (
          items.itemsPaymentDocument &&
          nfsUnique.indexOf(
            items.itemsPaymentDocument.paymentDocumentNumber !== -1
          )
        ) {
          nfsUnique.push(
            items.itemsPaymentDocument.paymentDocumentNumber
          );
        }
       });

      // função que exibe quantidade de notas fiscais únicas por pedido
      const setNFS = new Set(nfsUnique);

    function handleTotal(_data, item) {
      let packageValue = 0;
      let total = 0;
  
      if (!item.itemsPaymentDocument) return { packageValue, total };
  
      packageValue = item.itemsPaymentDocument.packageValue;
      total = item.itemsPaymentDocument.total;
  
      // if (data.status === "RECEIVED") {
      //   const otherCosts = data.otherCosts ? data.otherCosts : 0;
      //   const segCosts = data.segCosts ? data.segCosts : 0;
      //   const shipping = data.shipping ? data.shipping : 0;
      //   const discount = data.discount ? data.discount : 0;
  
      //   total = total + otherCosts + segCosts + shipping - discount;
      //   packageValue = total / item.costs.quantity;
      // }
  
      const fixedPackageValue = packageValue ? packageValue.toFixed(3) : '';
      const fixedTotalValue = total ? total.toFixed(3) : '';
  
      return { packageValue, total, fixedPackageValue, fixedTotalValue };
    }

  return (
    <>
      {openConfirmatioDialog && 
        <ConfirmationDialog
          sendReceivedscards={sendReceivedscards}
          openConfirmatioDialog={openConfirmatioDialog}
          setOpenConfirmatioDialog={setOpenConfirmatioDialog}
          handleSendReceiverRequest={handleSendReceiverRequest}
          modalLoading={modalLoading}
        />
      }

      {openModalOrder &&
        <DialogCompleteNoteMobile
          openModalOrder={openModalOrder}
          handleCloseModal={handleCloseModal}
          selectedReceiveDate={selectedReceiveDate}
          submitted={submitted}
          handleReceiveDateChange={handleReceiveDateChange}
          setSubmitted={setSubmitted}
          errMsg={errMsg}
          handleClose={handleClose}
          order={currentOrder}
          orders={orders}
          setOrders={setOrders}
          isCompleteNote={isCompleteNote}
          receiverData={receiverData}
          currentQuantity={currentQuantity}
          isDivergency={isDivergency}
          setIsDivergency={setIsDivergency}
          getData={getData}
          handleChangeStatusCard={handleChangeStatusCard}
        />
      }
      
      <AcrescimosDescontos
        openModalOrder={openModalDescontos}
        handleCloseModal={handleCloseModal}
        selectedReceiveDate={selectedReceiveDate}
        submitted={submitted}
        handleReceiveDateChange={handleReceiveDateChange}
        setSubmitted={setSubmitted}
        errMsg={errMsg}
        handleClose={handleClose}
        order={receiverData}
      />

      <Layout>

        <Snackbar open={toastSuccess} autoHideDuration={2000} onClose={handleCloseToast}>
          <Alert onClose={handleCloseToast} severity="success" >
            Itens Salvos Com Sucesso
          </Alert>
        </Snackbar> 
        
        <Snackbar open={toastError} autoHideDuration={2000} onClose={handleCloseToast}>
          <Alert onClose={handleCloseToast} severity="error" >
            Erro ao salvar os itens
          </Alert>
        </Snackbar> 

        {loading && <div sytle={{ margin: "10px" }}><LinearProgress style={{ height: "7px" }} variant="query" /></div>}
          
        <PullToRefresh className="customPullToRefreshSecondary" onRefresh={() => window.location.reload()}>
          <div className='cardNote' style={{
            height: `${size}`
          }}>
            <div className='dFlex' style={{padding: '8px'}}>
                <Link
                  to={{
                    pathname: `/recebimento/${paramsID}`,
                    state: { prevPath: 'receiveDetails' }
                  }}
                >
                  <img
                    className="cursorPointer"
                    style={{ width: '55px' }}
                    src={ArrowBack}
                    alt="ArrowBack"
                  />
                </Link>
              <div className='w100'>
                <div className='nfAndDate w100 dFlex justifyBetween'>
                  <div className='dFlex w100'>
                    <p>
                      {receiverData.isTransference ? 'TRANSFERENCIA': orders[0]?.itemsPaymentDocument?.paymentDocumentNumber == undefined ? "" : `NF ${orders[0]?.itemsPaymentDocument?.paymentDocumentNumber}`}
                      <span>
                        {`${[...setNFSUniqueReceived]?.length}/${[...setNFS]?.length
                                }`}
                      </span>
                    </p>
                  </div>
                  <p>
                    {format(new Date().valueOf() + 10800000, 'dd/MM/yy')}
                  </p>
                </div>
                <div
                    style={{
                      border: `1px solid ${backgroundColorStatus(
                        receiverData.status,
                        receiverData.deliveryDate,
                        receiverData
                      )}`,
                      color: wordColorStatus(
                        receiverData.status,
                        receiverData.deliveryDate,
                        receiverData
                      ),
                      minWidth:'168px'
                    }}
                    className='justifyCenter dFlex statusBox pt2'
                  >
                  {handleTranslateStatus(
                    receiverData.status,
                    receiverData.deliveryDate,
                    receiverData
                  )}
                </div>

              </div>
            </div>
            <div className='w100'>
              <div className='descriptionReceive'>
                {receiverData?.providerName}
              </div>
              <div className='orderReceipt'>
                <div className='dFlex justifyAround'>
                  <div className='totalOrder'>
                    <p>TOTAL PEDIDO</p>
                    <h1>R${receiverData.isTransference ? 
                      numberToReal(parseFloat(receiverData?.orderItems[0]?.costs?.total, 2))
                      : receiverData?.orderItems
                        ?.reduce(
                          (total, valor) =>
                            valor?.costs
                              ? parseFloat(total) + parseFloat(valor?.costs?.total)
                              : total + 0,
                          0
                        )
                        .toLocaleString('pt-br', { minimumFractionDigits: 3 })}
                    </h1>
                  </div>
                  <div className='totalReceipt'>
                    <p>TOTAL RECEBIMENTO</p>
                    <h1>R${receiverData.isTransference ? 
                      numberToReal(parseFloat(handleTotal(orders, receiverData?.orderItems[0]).total), 2)
                      : numberToReal(orders?.length == 0 ? receiverData?.totalPaymentDocument : totalReceiver, 2)}
                    </h1>
                  </div>
                </div>
                <div className='additionsDiscounts'>
                  <p style={{color: `${showTooltipNotes(receiverData?.orderItems) ? '#5062F0' : '#9296ac'}`}}>Pedido com Acréscimos e/ou Descontos</p>
                </div>
                <div className='buttonNote'>
                  <button onClick={openCompleteNoteModal} >
                    <DoneIcon style={{color: "#FFF", marginRight: '8px', marginBottom: '4px'}} fontSize='inherit' />
                    Receber Nota completa
                  </button>
                </div>
              </div>
            </div>
          </div>
        
          <div className="detailCard" style={{
            marginTop: size !== 'auto' ? '25px' : '10px',
            height: 'auto'
          }}>
            <div className="lengthItens" >
              <p>{orders?.length} ITENS</p>
            </div>

            {orders.map(order => (
              <ReceiverDetailsCards
                key={order.id}
                cardId={order._id}
                order={order}
                orders={orders}
                loading={loading}
                setOrders={setOrders}
                receiverData={receiverData}
                openModalOrder={openModalOrder}
                setOpenModalOrder={setOpenModalOrder}
                isCompleteNote={isCompleteNote}
                setIsCompleteNote={setIsCompleteNote}
                setCurrentOrder={setCurrentOrder}
                currentQuantity={currentQuantity}
                setCurrentQuantity={setCurrentQuantity}
                isDivergency={isDivergency}
                setIsDivergency={setIsDivergency}
                totalCards={totalCards}
                setTotalCards={setTotalCards}
                openFloatButton={openFloatButton}
                setOpenFloatButton={setOpenFloatButton}
                sendReceivedscards={sendReceivedscards}
                setSendReceivedscards={setSendReceivedscards}
                handleReceivementDate={handleReceivementDate}
                receivementDate={receivementDate}
                />
            ))}
          </div>
            
          {openFloatButton ? 
            <div
              className="fabButton"
            >
              {loading ?
                <div style={{display: "flex", justifyContent: "center", width: "100%"}} >
                  <CircularProgress style={{color: "white"}} />
                </div>
              : 
                <>
                  <div className="confirmationButtonDate" >
                    <p>DATA</p>
                    <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        format="dd/MM/yyyy"
                        InputAdornmentProps={{ position: "start" }}
                        value={receivementDate}
                        onChange={handleReceivementDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                    </div>
                  </div>

                  <div
                    onClick={handleSendReceiverRequest}
                    className="confirmationButtonSend"
                  >
                    <p>RECEBER</p>
                    <img src={ArrowRight} alt="seta para direita" />
                  </div>
              </>
              }
            </div>
          : null }
        </PullToRefresh>
        <OverlayFooter/>
      </Layout>
    </>
  )
}

export default ReceiverDetails;
